import { getTopWindow } from './window'

export default class crossTabData {

    callback = (data) => { console.log(data); }

    handler = (e) => {
        console.log(e);
        let { type, crossTabData } = e.data || {};
        if (type === 'crossTabData') {
            this.callback(crossTabData);
        }
    }
    on = (type, callback, useCapture = false) => {
        this.callback = callback;
        if (type === 'message') {
            getTopWindow().addEventListener(type, this.handler, useCapture)
        }
        let crossTabData = getTopWindow().crossTabData || top.crossTabData;
        if (crossTabData) {
            getTopWindow().postMessage({ type: 'crossTabData', crossTabData });
        }

    }
    destroy = (type, callback) => {
        if (type === 'message') {
            getTopWindow().removeEventListener(type, this.handler)
        }
    }
}